import { IParaviewColumnMapping } from "@/types/dataset";
import { defineStore } from "pinia";
import { useLayerStore as layer } from "./layer";
import { usePvwStore as pvw } from "./pvw";
import { useViewStore as views } from "./views";
export type ISelectedDatasets = {
	[viewId: string]: { [datasetId: string]: boolean };
};
// --------------------------------------------------------------------------------------

const TO_ITEM = ({
	label,
	prop,
	is_default,
	column,
	sort_order,
	prop_group
}: {
	label: any;
	prop: any;
	is_default: any;
	column: any;
	sort_order: any;
	prop_group: any;
}) => ({
	text: label,
	column,
	sort_order,
	prop_group,
	value: prop,
	is_default: is_default == "Y"
});
const FILTER_BY = (item: IParaviewColumnMapping) => item.isFilterBy === "true";
const COLOR_BY = (item: IParaviewColumnMapping) => item.isColorBy === "true";
// const DEFAULT = (item: IParaviewColumnMapping) => item.isD === "Y";

const getItemsCache: any = {};

// --------------------------------------------------------------------------------------
function isEquivalent(a: any, b: any) {
	const aProps = Object.getOwnPropertyNames(a);
	const bProps = Object.getOwnPropertyNames(b);
	if (aProps.length != bProps.length) {
		return false;
	}
	for (let i = 0; i < aProps.length; i++) {
		const propName = aProps[i];

		if (a[propName] !== b[propName]) {
			return false;
		}
	}
	return true;
}
function getItems(layerDatasetColumnMapping: IParaviewColumnMapping[], filterFn: any) {
	// # todo - convert to getting paraview payload and translating with IParaviewColumnMapping ?
	if (layerDatasetColumnMapping == null) return [];
	if (layerDatasetColumnMapping.length == 0) return [];
	if (!("column" in layerDatasetColumnMapping) || !("label" in layerDatasetColumnMapping)) {
		return [];
	}
	// # todo-reimplement cache (after code cleanup of this section)
	// if (getItemsCache[joinedArgs]) {
	// 	return getItemsCache[joinedArgs];
	// }

	const baseList = [];
	// const config = JSON.parse(JSON.stringify(layerConfig));
	return layerDatasetColumnMapping;
	// if (config && config.mapping) {
	// 	//let arrayToAdd = config.mapping.filter(filterFn).map(TO_ITEM);
	// 	const retval = baseList.concat(config.mapping.filter(filterFn).map(TO_ITEM));
	// 	getItemsCache[joinedArgs] = retval;
	// 	return retval;
	// }
}

// --------------------------------------------------------------------------------------

export const useActiveStore = defineStore("activeStore", {
	state: () =>
		({
			view: "",
			subview: "",
			layerByView: {},
			panel: 0,
			dataset: {},
			selectedDatasets: {}
		}) as {
			view: string;
			subview: string;
			layerByView: any;
			panel: number;
			dataset: any;
			selectedDatasets: ISelectedDatasets;
		},
	getters: {
		SSA_ACTIVE_DATASET(): any {
			return this.dataset[this.view];
		},
		SSA_SELECTED_DATASETS(): any {
			return this.selectedDatasets[this.view];
		},
		SSA_ACTIVE_PANEL(): any {
			return this.panel;
		},
		SSA_ACTIVE_VIEW(): string {
			return this.view;
		},
		SSA_ACTIVE_SUB_VIEW(): any {
			return this.subview;
		},
		SSA_ACTIVE_LAYER(): any {
			return this.layerByView[this.view];
		},
		SSA_ACTIVE_LAYER_BY_VIEW(): any {
			return this.layerByView;
		},
		SSA_ACTIVE_LAYER_CONFIG(): any {
			const paraviewConfig: any = pvw().paraviewConfig; //getters.SSA_MINE_MENU_DATA;
			if (paraviewConfig == null) return null;
			const activeLayer = this.SSA_ACTIVE_LAYER;
			return paraviewConfig[activeLayer];
		},
		SSA_ACTIVE_LAYER_STATE(): any {
			const map = layer().SSA_LAYER_STATES;
			const viewId = this.view;
			const layerName = this.SSA_ACTIVE_LAYER;
			return map[viewId] && map[viewId][layerName];
		},
		SSA_ACTIVE_REPRESENTATION_STATE(): any {
			const map = layer().SSA_REPRESENTATION_STATES;
			const viewId = this.view;
			const layerName = this.SSA_ACTIVE_LAYER;

			return map[viewId] && map[viewId][layerName];
		},
		SSA_ACTIVE_SELECTION_SIZE(): any {
			//   const map = getters.SSA_SELECTION_SIZES;
			//   const viewId = this.SSA_ACTIVE_VIEW;
			//   const layerName = this.SSA_ACTIVE_LAYER;
			//   return (map[viewId] && map[viewId][layerName]) || 0;
			return "TODO";
		},
		SSA_ACTIVE_LAYER_CAPABILITY(): any {
			//   const layerName = this.SSA_ACTIVE_LAYER;
			//   const capabilities = getters.SSA_MINE_CAPABILITY_MAP;
			//   return (capabilities && capabilities[layerName]) || {};
			return "TODO";
		},
		// -- ui helpers --
		// #todo - revert removed placeholder code after reviewing if use in MVP has benefits
		SSA_ACTIVE_THRESHOLD_FIELDS(): any {
			const activeLayer = this.SSA_ACTIVE_LAYER_CONFIG;
			return getItems(activeLayer, FILTER_BY);
		},
		SSA_ACTIVE_COLORBY_FIELDS(): any {
			const activeLayer = this.SSA_ACTIVE_LAYER_CONFIG;
			if (activeLayer == null) {
				return null;
			}
			const items = getItems(activeLayer, COLOR_BY);
			// const colorbyitems = items.concat(getItems(activeLayer, DEFAULT));
			// colorbyitems = _.sortBy(colorbyitems, [
			// 	function (o) {
			// 		return o.text.toLowerCase();
			// 	}
			// ]);
			return items;
		},
		SSA_ACTIVE_ITEM_HAS(): any {
			//   const viewId = this.SSA_ACTIVE_VIEW;
			//   const layerName = this.SSA_ACTIVE_LAYER;
			//   const fn = getters.SSA_UI_ITEM_HAS;
			//   return (type:any) => fn(layerName, viewId, type);
			return "TODO";
		},
		SSA_ACTIVE_ITEM_REPRESENTATION_HAS_PROPERTY(): any {
			//   const viewId = this.SSA_ACTIVE_VIEW;
			//   const layerName = this.SSA_ACTIVE_LAYER;
			//   const fn = getters.SSA_UI_ITEM_REPRESENTATION_HAS_PROPERTY;
			//   return (type:any, propertyName:any) => fn(layerName, viewId, type, propertyName);
			return "TODO";
		},
		SSA_ACTIVE_ITEM_VISIBILITY(): any {
			//   const viewId = this.SSA_ACTIVE_VIEW;
			//   const layerName = this.SSA_ACTIVE_LAYER;
			//   const fn = getters.SSA_UI_ITEM_VISIBILITY;
			//   return (type:any) => fn(layerName, viewId, type);
			return "TODO";
		},
		SSA_ACTIVE_ITEM_STYLE(): any {
			//   const viewId = this.SSA_ACTIVE_VIEW;
			//   const layerName = this.SSA_ACTIVE_LAYER;
			//   const fn = getters.SSA_UI_ITEM_STYLE;
			//   return (type:any) => fn(layerName, viewId, type);
			return "TODO";
		}
	},
	actions: {
		SSA_REFRESH_ACTIVE_DATASET(): any {
			this.dataset[this.view] = { ...this.dataset[this.view], seed: Math.random() };
		},
		SSA_SET_ACTIVE_DATASET(value: any) {
			this.dataset[this.view] = value;
		},
		SSA_UPDATE_DATASET_IN_VIEWS(dataset: any) {
			views().SSA_VIEW_IDS.forEach((viewId) => {
				if (this.dataset[viewId] && this.dataset[viewId].id === dataset.id) {
					console.log(`🐢 Updating dataset for view ${viewId}`);
					// Replace the dataset for this view
					this.dataset[viewId] = dataset;
				}
			});
		},
		SSA_SET_SELECTED_ON_STATE_LOAD(newSelectedDatasetsMap: ISelectedDatasets) {
			this.selectedDatasets = newSelectedDatasetsMap;
		},
		SSA_SET_DATASET(value: any) {
			this.dataset = value;
		},
		SSA_SET_SELECTED_DATASETS(value: any) {
			this.selectedDatasets = value;
		},
		SSA_SET_DATASETS_SELECTED(value: any, isTurnOff = false, currentSelections = []) {
			const valueId = typeof value === "object" && value !== null ? value.id : value;
			const childrenSelected = currentSelections.filter(
				(selection: any) => selection.indexOf(valueId) > -1
			).length;
			if (this.selectedDatasets[this.view]) {
				if (isTurnOff && childrenSelected === 0) {
					delete this.selectedDatasets[this.view][valueId];
				} else {
					this.selectedDatasets[this.view][valueId] = true;
				}
			} else {
				this.selectedDatasets[this.view] = {};
				if (isTurnOff) delete this.selectedDatasets[this.view][valueId];
				else this.selectedDatasets[this.view][valueId] = true;
			}
		},
		SSA_ACTIVE_PANEL_SET(value: any) {
			this.panel = value;
		},
		SSA_ACTIVE_VIEW_SET(value: any) {
			this.view = value;
		},
		SSA_ACTIVE_SUB_VIEW_SET(value: any) {
			this.subview = value;
		},
		SSA_ACTIVE_LAYER_BY_VIEW_SET(value: any) {
			this.layerByView = value;
		},
		SSA_ACTIVE_LAYER_SET(value: any) {
			//if (value != null && this.layerByView[this.view] != value) {
			this.layerByView[this.view] = value;
			//} else {
			//	this.layerByView[this.view] = null;
			//}
		},
		SSA_ACTIVE_RESET() {
			this.view = "";
			this.layerByView = {};
		},

		SSA_ACTIVELAYER_RESET_BY_VIEW(viewId: any) {
			const newState = Object.assign({}, this.layerByView);
			delete newState[viewId];
			this.SSA_ACTIVE_LAYER_BY_VIEW_SET(newState);
		},

		SSA_ACTIVELAYER_RESET() {
			this.SSA_ACTIVE_LAYER_BY_VIEW_SET({});
		},
		async SSA_ACTIVE_VIEW_RESET_CAMERA() {
			const viewId = this.SSA_ACTIVE_VIEW;
			pvw().PVW_RESET_CAMERA({ viewId });
		},
		async SSA_ACTIVE_VIEW_RESET_VIEW_UP(viewType: any) {
			//   const viewId = this.SSA_ACTIVE_VIEW;
			//   const northPole = !getters.SSA_MINEDOMAIN_CONFIG.USESOUTHPOLECONFIG == true;
			//   return pvw().PVW_SET_VIEW_UP({ viewId, viewType, northPole });
			return viewType;
		}
	},
	persist: false
});
